<template>
  <!-- 订单流水 显示每月组件 -->
  <div class="order-list-container">
    <div class="month-content">
      <div class="month">
        <span>{{ dataList.monthShow }}</span
        >月
      </div>
      <div class="history">
        <div class="right">
          <span class="title">充值</span>
          <span class="money"> ￥{{ dataList.rechargeTotal }}</span>
        </div>
        <div class="center">
          <span class="title">消费</span>
          <span class="money"> ￥{{ dataList.consumptionTotal }}</span>
        </div>
      </div>
    </div>
    <div class="day-content">
      <template v-for="(monthData, index) in [...dataList.queryOrderFlowVoList].reverse()">
        <div class="day-item" :key="index" v-if="monthData.length">
          <div class="title-day">
            <van-tag round color="#999" type="primary"
              >{{ dataList.monthShow }}.{{ 31 - index }}</van-tag
            >
          </div>
          <div class="day-list">
            <div
              class="day-list-item"
              @click="toDetail(day)"
              v-for="day in monthData"
              :key="day.time"
            >
              <div class="left">
                <img src="../../../assets/icon/money.png" alt="" />
              </div>
              <div class="right">
                <div class="top">
                  <span v-if="day.orderType == 0">充值</span>
                  <span v-if="day.orderType == 1">消费</span>
                  <span>￥{{ day.money }}</span>
                </div>
                <div class="center">
                  <div class="client">
                    <span>顾客:</span> <span>{{ day.mobile }}</span>
                  </div>
                </div>
                <div class="bottom">
                  <span v-show="!isSubAccount">导购:</span>
                  <span v-show="!isSubAccount">{{ day.guide }}</span>
                  <span>{{ day.time }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name:"orderList",
  props: {
    //数据列表
    dataList: {
      type: Object,
    },
    //是否是子账号
    isSubAccount: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      datas:[]
    }
  },
  methods: {
    toDetail(value) {
      if (value.orderType == "1") {
         this.$router.push({
          name: "OrderDeatil",
          query: {
            orderName: value.orderName,
            orderType: value.orderType,
          },
        });
      } else {
       this.$router.push({
          name: "OrderMoney",
          query: {
            orderName: value.orderName,
            orderType: value.orderType,
          },
        });
      }
    },
  },
};
</script>


<style lang="less" scopd>
@import url("../../../assets/css/order/orderList.less");
</style>